<template>
<div class="container">
    <div class="row">
        <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9" style="padding: 0">
            <form class="form-inline" role="form">
                <div class="form-group">
                    <label class="sr-only" for="name">数值</label>
                    <input v-model.number="inputValue" type="text" class="form-control text-right" placeholder="请输入数值"  style="width:220px">
                </div>
                <div class="form-group">
                    <select class="form-control" v-model="srcUnit" style="width:170px">
                        <option disabled value="">请选择</option>
                        <option v-for="(unit,index) in units.list" v-bind:value="index">{{ unit.text + (unit.short ? '(' + unit.short + ')' : '') }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <button type="button" class="btn btn-default btn-xs" @click="exchangeUnit"><i class="glyphicon glyphicon-resize-horizontal"></i></button>
                </div>
                <div class="form-group">
                    <select class="form-control" v-model="dstUnit" style="width:170px">
                    <option disabled value="">请选择</option>
                        <option v-for="(unit,index) in units.list" :value="index">{{ unit.text + (unit.short ? '(' + unit.short + ')' : '') }}</option>
                    </select>
                </div>
            </form>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
            <h3 class="text-center" v-if="computeResult">{{ computeResult }}</h3>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-xs-12 col-sm-9 col-md-9 col-lg-9">
            <div class="text-right">
                <span class="text-right text-muted" style="font-size:14px">国际单位：{{ commonUnit }}</span>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
  name: 'UnitConvertor',
  props: {
    units: Object
  },
  data : function () {
        return {
        inputValue: '',
        srcUnit: '',
        dstUnit: ''
        }
    },
    methods: {
        exchangeUnit: function () {
            var unit = this.srcUnit
            this.srcUnit = this.dstUnit
            this.dstUnit = unit
        },
    },
    computed: {
        commonUnit: function () {
            var unitObj = this.units.list[this.units.commonUnit]
            return unitObj.text + '(' + unitObj.short + ')'
        },
        computeResult: function () {
            var result = ''
            
            if (this.inputValue !== '' &&　this.srcUnit !== '' && this.dstUnit !== ''){
                var srcUnitObj = this.units.list[this.srcUnit]
                var dstUnitObj = this.units.list[this.dstUnit]
                var dstValue = (srcUnitObj.value / dstUnitObj.value * this.inputValue).toFixed(6)
                dstValue = parseFloat(dstValue)

                return this.inputValue + ' ' + srcUnitObj.text + (srcUnitObj.short ? '(' + srcUnitObj.short + ')' : '')
                + ' = ' + dstValue + ' ' + dstUnitObj.text + (dstUnitObj.short ? '(' + dstUnitObj.short + ')' : '')
            }

            return result
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
